import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DiscountsService } from '../../../../services/discounts.service';
import { Discount } from '../../../../interfaces/discount';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-discount-select-dialog',
  templateUrl: './discount-select-dialog.component.html',
  styleUrls: ['./discount-select-dialog.component.scss']
})
export class DiscountSelectDialogComponent implements OnInit {
  public discountAddForm: FormGroup;
  public discounts: Discount[];
  public discount: Discount;
  public readonly discountValue: number = 5;

  constructor(
    public dialogRef: MatDialogRef<DiscountSelectDialogComponent>,
    private discountService: DiscountsService,
    public translate: TranslateService
  ) {
    this.discountAddForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      code: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    this.discountService.getAllDiscounts().subscribe(discounts => {
      this.discounts = discounts;
    });
  }

  save() {
    this.dialogRef.close(this.discount);
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-edit/discount-select-dialog/discount-select-dialog.component.ts